import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import UIGlobalStyles from '@lt/components/styles/styles';
import ErrorBoundary from 'src/error/components/ErrorBoundary';

import Layout from 'src/components/Layout';
import LazySeamlessTBankAuth from 'src/components/SeamlessTBankAuth';
import { getStore } from './store';

import SearchPage from './components/SearchPage';
import { MODULE_NAME } from '../../constants';

interface ISearchPageApp {
  searchType?: string;
}

const SearchPageApp = (props: ISearchPageApp) => {
  const { searchType } = props;

  if (!searchType) {
    // TODO: Я бы тут реализовал модальное окно, которое будет выводить ошибку
    // eslint-disable-next-line no-console
    console.error('Поле searchType не объявлено');
  }

  return (
    <ErrorBoundary>
      <Provider store={getStore(props)}>
        <UIGlobalStyles />
        <UserflowTheme>
          <Layout appName={MODULE_NAME.SEARCH}>
            <>
              <SearchPage />
              <LazySeamlessTBankAuth />
            </>
          </Layout>
        </UserflowTheme>
      </Provider>
    </ErrorBoundary>
  );
};

export default SearchPageApp;
